// SnackbarUtils.js
import { useSnackbar } from "notistack";
import { SNACKBAR_CONSTANTS } from "../../utils/constants";

// 1. Create a reference to hold the function
let useSnackbarRef;

export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null; // This component renders nothing
};

// 2. Create the wrapper function that non-React files will use
export default {
  success(msg) {
    this.toast(msg, "success");
  },
  warning(msg) {
    this.toast(msg, "warning");
  },
  info(msg) {
    this.toast(msg, "info");
  },
  error(msg) {
    // Using your custom variant from the previous step
    this.toast(msg, "enphaseError");
  },
  toast(msg, variant = "default") {
    if (useSnackbarRef) {
      useSnackbarRef.enqueueSnackbar(msg, { variant, autoHideDuration: SNACKBAR_CONSTANTS.HIDE_DURATION });
    } else {
      // SnackbarUtils not initialized — no-op
    }
  },
};
